'use client'
import {
  Button,
  OpeningTitle,
  Paragraph,
  Section,
  Title,
} from '@dynamo-caffeina-dev/airc-ui-kit'

import {
  ButtonProps,
  NormalizedSection,
  OpeningTitleProps,
  ParagraphProps,
  TitleProps,
} from '@/types'

import ActionCluster, {
  ActionClusterProps,
} from '@/components/organisms/ActionCluster'
import { dispatchGTMEvent, GTM_EVENT_CATEGORY } from '@/helpers/gtm'

export interface SupportUsProps extends NormalizedSection {
  modelledContent: {
    openingTitle: OpeningTitleProps
    title: TitleProps
    paragraph: ParagraphProps
    cta: ButtonProps
    actions: ActionClusterProps['items']
  }
}

const SupportUs = ({ modelledContent }: SupportUsProps) => {
  const { openingTitle, title, paragraph, cta, actions } = modelledContent

  const handleCtaClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    dispatchGTMEvent(GTM_EVENT_CATEGORY.DISTRIBUTION)
    if (cta.onClick) cta.onClick(event)
  }

  return (
    <Section className='section-support-us'>
      <div className='section-wrapper'>
        <div className='section-intro'>
          <OpeningTitle {...openingTitle}>{openingTitle.content}</OpeningTitle>
          <div className='section-intro--content'>
            <Title
              {...title}
              dangerouslySetInnerHTML={{ __html: title.content || '' }}
            />
            <Paragraph
              as={'div'}
              dangerouslySetInnerHTML={{ __html: paragraph.content || '' }}
            />
            <Button
              {...cta}
              target={'_blank'}
              variant={'themed'}
              onClick={handleCtaClick}
            >
              {cta.content}
            </Button>
          </div>
        </div>
        <div className='section-content'>
          <ActionCluster items={actions} />
        </div>
      </div>
    </Section>
  )
}

export default SupportUs
